import {Stack} from '@mui/material';
import styled from 'styled-components';

const Container = styled(Stack)`
	padding: 16px;
	margin: 24px auto;

	height: 100%;
	width: 618px;
	${({theme}) => theme.breakpoints.down('sm')} {
		width: calc(100% - 32px);
		margin: 16px auto;
	}
`;

export {Container};
